export const ACTION_PREFIX = 'MODULE/PROPERTY_TYPE'
